import { render, staticRenderFns } from "./tc.vue?vue&type=template&id=d9ef5fea&scoped=true&"
import script from "./tc.vue?vue&type=script&lang=js&"
export * from "./tc.vue?vue&type=script&lang=js&"
import style0 from "./tc.vue?vue&type=style&index=0&id=d9ef5fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ef5fea",
  null
  
)

export default component.exports